import { compareDocumentOrder } from "./compareDocumentOrder";

const emptyItems = [] as never[];
// Component input watches require a stable result while the immutable source reference is unchanged.
const orderedItems = new WeakMap<
	ReadonlyArray<unknown>,
	Map<PropertyKey | undefined, ReadonlyArray<unknown>>
>();

export function orderByDocumentPosition<T>(
	items?: ReadonlyArray<T> | null,
	elementProperty?: keyof T
): ReadonlyArray<T> {
	if(!items) {
		return emptyItems;
	}

	let orders = orderedItems.get(items);
	if(!orders) {
		orders = new Map();
		orderedItems.set(items, orders);
	}

	const existing = orders.get(elementProperty);
	if(existing) {
		return existing as ReadonlyArray<T>;
	}

	const getElement = (item: T): Node | undefined =>
		(elementProperty !== undefined ? item[elementProperty] : item) as Node | undefined;
	const ordered = [...items].sort((first, second) =>
		compareDocumentOrder(getElement(first), getElement(second)));

	orders.set(elementProperty, ordered);
	return ordered;
}
